// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UrtY6k {
  color: var(--icon-neutral-medium);
  width: 16px;
  height: 16px;
}

.xpaBh6 {
  width: 100%;
}

._4ZtKK_ {
  background: var(--surface-neutral-pale);
  border-color: var(--surface-neutral-pale);
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/BeneficiaryFilter/components/BeneficiarySearchInput/BeneficiarySearchInput.module.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,WAAW;AACb","sourcesContent":[".searchIcon {\n  color: var(--icon-neutral-medium);\n  width: 16px;\n  height: 16px;\n}\n\n.searchInput {\n  width: 100%;\n}\n\n.searchInputContainer {\n  background: var(--surface-neutral-pale);\n  border-color: var(--surface-neutral-pale);\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchIcon": `UrtY6k`,
	"searchInput": `xpaBh6`,
	"searchInputContainer": `_4ZtKK_`
};
module.exports = ___CSS_LOADER_EXPORT___;
